import { FC } from 'react';
// 组件
import { QuestionCircleOutlined } from '@ant-design/icons';
import { ProTooltip } from '../../../antd';
// 常量
import { CardHeaderProps } from '../../interface';

/** 头部 */
const CardHeader: FC<CardHeaderProps> = props => {
  const { title, subTitle, toolTipText, } = props;
  if (!title && !subTitle && !toolTipText) return null;
  return (
    <div className="form-card-header">
      <div className="form-card-header-title">
        <div>
          {
            !!title && <span className="form-card-header-title-text">{title}</span>
          }
          {
            !!subTitle && <span className="form-card-header-title-sub">{subTitle}</span>
          }
        </div>
        {
          !!toolTipText && (
            <ProTooltip title={toolTipText}>
              <QuestionCircleOutlined />
            </ProTooltip>
          )
        }
      </div>
    </div>
  );
};

export default CardHeader;